module.exports = __webpack_public_path__ + "img/tg.6bb1e42e.png";